"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestDatabaseNames = requestDatabaseNames;
exports.requestDatabase = requestDatabase;
exports.requestData = requestData;
exports.getMetadata = getMetadata;
exports.deleteObjectStoreEntries = deleteObjectStoreEntries;
exports.clearObjectStore = clearObjectStore;
exports.deleteDatabase = deleteDatabase;
var each_1 = __importDefault(require("licia/each"));
var map_1 = __importDefault(require("licia/map"));
var isStr_1 = __importDefault(require("licia/isStr"));
var isArr_1 = __importDefault(require("licia/isArr"));
var objManager = __importStar(require("../lib/objManager"));
var indexedDB = window.indexedDB;
var databaseVersions = {};
function requestDatabaseNames() {
    return __awaiter(this, void 0, void 0, function () {
        var databases, databaseNames;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, indexedDB.databases()];
                case 1:
                    databases = _a.sent();
                    databaseNames = [];
                    databaseVersions = {};
                    (0, each_1.default)(databases, function (database) {
                        if (!database.name) {
                            return;
                        }
                        databaseVersions[database.name] = database.version;
                        databaseNames.push(database.name);
                    });
                    return [2, {
                            databaseNames: databaseNames,
                        }];
            }
        });
    });
}
function requestDatabase(params) {
    return __awaiter(this, void 0, void 0, function () {
        var databaseName, version, objectStores, db, storeList;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    databaseName = params.databaseName;
                    version = databaseVersions[databaseName];
                    objectStores = [];
                    return [4, promisify(indexedDB.open(databaseName))];
                case 1:
                    db = _a.sent();
                    if (db.objectStoreNames.length) {
                        storeList = (0, map_1.default)(db.objectStoreNames, function (name) {
                            return db.transaction(name, 'readonly').objectStore(name);
                        });
                        (0, each_1.default)(storeList, function (store) {
                            var indexes = [];
                            (0, each_1.default)(store.indexNames, function (indexName) {
                                var index = store.index(indexName);
                                indexes.push({
                                    name: index.name,
                                    multiEntry: index.multiEntry,
                                    keyPath: formatKeyPath(index.keyPath),
                                    unique: index.unique,
                                });
                            });
                            objectStores.push({
                                name: store.name,
                                indexes: indexes,
                                keyPath: formatKeyPath(store.keyPath),
                                autoIncrement: store.autoIncrement,
                            });
                        });
                    }
                    return [2, {
                            databaseWithObjectStores: {
                                name: databaseName,
                                objectStores: objectStores,
                                version: version,
                            },
                        }];
            }
        });
    });
}
function requestData(params) {
    return __awaiter(this, void 0, void 0, function () {
        var databaseName, objectStoreName, indexName, pageSize, skipCount, db, objectStore, count, currentIdx, cursorRequest, index;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    databaseName = params.databaseName, objectStoreName = params.objectStoreName, indexName = params.indexName, pageSize = params.pageSize, skipCount = params.skipCount;
                    return [4, promisify(indexedDB.open(databaseName))];
                case 1:
                    db = _a.sent();
                    objectStore = db
                        .transaction(objectStoreName, 'readonly')
                        .objectStore(objectStoreName);
                    return [4, promisify(objectStore.count())];
                case 2:
                    count = _a.sent();
                    currentIdx = 0;
                    if (indexName) {
                        index = objectStore.index(indexName);
                        cursorRequest = index.openCursor();
                    }
                    else {
                        cursorRequest = objectStore.openCursor();
                    }
                    return [2, new Promise(function (resolve, reject) {
                            var objectStoreDataEntries = [];
                            cursorRequest.addEventListener('success', function () {
                                var cursor = cursorRequest.result;
                                if (cursor && currentIdx < pageSize + skipCount) {
                                    if (currentIdx >= skipCount) {
                                        objectStoreDataEntries.push({
                                            key: objManager.wrap(cursor.key, {
                                                generatePreview: true,
                                            }),
                                            primaryKey: objManager.wrap(cursor.primaryKey),
                                            value: objManager.wrap(cursor.value, {
                                                generatePreview: true,
                                            }),
                                        });
                                    }
                                    cursor.continue();
                                    currentIdx++;
                                }
                                else {
                                    resolve({
                                        hasMore: currentIdx < count,
                                        objectStoreDataEntries: objectStoreDataEntries,
                                    });
                                }
                            });
                            cursorRequest.addEventListener('error', reject);
                        })];
            }
        });
    });
}
function getMetadata(params) {
    return __awaiter(this, void 0, void 0, function () {
        var databaseName, objectStoreName, objectStore;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    databaseName = params.databaseName, objectStoreName = params.objectStoreName;
                    return [4, getObjectStore(databaseName, objectStoreName)];
                case 1:
                    objectStore = _b.sent();
                    _a = {};
                    return [4, promisify(objectStore.count())];
                case 2: return [2, (_a.entriesCount = _b.sent(),
                        _a.keyGeneratorValue = 1,
                        _a)];
            }
        });
    });
}
function deleteObjectStoreEntries(params) {
    return __awaiter(this, void 0, void 0, function () {
        var databaseName, objectStoreName, keyRange, objectStore;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    databaseName = params.databaseName, objectStoreName = params.objectStoreName, keyRange = params.keyRange;
                    return [4, getObjectStore(databaseName, objectStoreName)];
                case 1:
                    objectStore = _a.sent();
                    return [4, promisify(objectStore.delete(IDBKeyRange.bound(getKeyRangeBound(keyRange.lower), getKeyRangeBound(keyRange.upper), keyRange.lowerOpen, keyRange.upperOpen)))];
                case 2:
                    _a.sent();
                    return [2];
            }
        });
    });
}
function clearObjectStore(params) {
    return __awaiter(this, void 0, void 0, function () {
        var databaseName, objectStoreName, objectStore;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    databaseName = params.databaseName, objectStoreName = params.objectStoreName;
                    return [4, getObjectStore(databaseName, objectStoreName)];
                case 1:
                    objectStore = _a.sent();
                    return [4, promisify(objectStore.clear())];
                case 2:
                    _a.sent();
                    return [2];
            }
        });
    });
}
function deleteDatabase(params) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, promisify(indexedDB.deleteDatabase(params.databaseName))];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    });
}
function getKeyRangeBound(key) {
    return key.number || key.string || key.date || key.array || key;
}
function getObjectStore(databaseName, objectStoreName) {
    return __awaiter(this, void 0, void 0, function () {
        var db, objectStore;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, promisify(indexedDB.open(databaseName))];
                case 1:
                    db = _a.sent();
                    objectStore = db
                        .transaction(objectStoreName, 'readwrite')
                        .objectStore(objectStoreName);
                    return [2, objectStore];
            }
        });
    });
}
function formatKeyPath(keyPath) {
    if ((0, isStr_1.default)(keyPath)) {
        return {
            type: 'string',
            string: keyPath,
        };
    }
    if ((0, isArr_1.default)(keyPath)) {
        return {
            type: 'array',
            array: keyPath,
        };
    }
    return {
        type: 'null',
    };
}
function promisify(req) {
    return new Promise(function (resolve, reject) {
        req.addEventListener('success', function () {
            resolve(req.result);
        });
        req.addEventListener('error', function () {
            reject();
        });
    });
}
